import DapDSFileInputListItem from './file-input-list-item.component'

export * from './file-input-list-item.component'
export default DapDSFileInputListItem

DapDSFileInputListItem.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-file-input-list-item': DapDSFileInputListItem
  }
}
